export class JwtTokenLoggerHelper {
  public static logToken(token: string, logprefix?: string): void {
    const lp = logprefix || '';
    if (!token) {
      console.log(`${lp} logToken: token is empty`);
      return;
    }

    try {
      const payloadParsed = this.parsedToken(token);
      const issuedAt = new Date(payloadParsed.iat * 1000).toISOString();
      const expires = new Date(payloadParsed.exp * 1000).toISOString();
      console.log(`${lp} logToken: eventId=${payloadParsed.event_id} / iat=${issuedAt} / exp=${expires}`);
    } catch (e) {
      console.log(`${lp} logToken: error logging token`, e);
    }
  }

  private static parsedToken(token: string): {
    iat: number;
    exp: number;
    event_id: string;
  } {
    return JSON.parse(atob(token.split('.')[1]));
  }

  public static getEventId(token: string): string {
    if (!token) {
      return '';
    }

    try {
      return this.parsedToken(token).event_id;
    } catch (e) {
      console.log('getEventId', e);
    }
    return '';
  }
}
